const styles = {
  modalStyle: {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)",
      zIndex: 1000
    },
    content: {
      position: "absolute",
      top: 0,
      bottom: "8px",
      left: "8px",
      right: "8px",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "8px",
      outline: "none",
      padding: "20px",
      maxWidth: "700px",
      maxHeight: "80%",
      height: "fit-content",
      margin: "auto",
      border: "2px solid blue"
    }
  }
};

export default styles;
